/**
 * @fileoverview Componente responsável por inserir variáveis em mensagens e templates.
 */

import React from "react";
import { Chip, makeStyles } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import OutlinedDiv from "../OutlinedDiv";

const useStyles = makeStyles(theme => ({
    chip: {
        margin: theme.spacing(0.5),
        cursor: "pointer"
    }
}));

// Lista estática fora do componente — nunca muda (exceto ao trocar idioma,
// o que dispara remount da árvore i18n). Evita recriar o array em cada render.
const MSG_VARS = [
    { name: i18n.t("messageVariablesPicker.vars.contactFirstName"), value: "{{firstName}}" },
    { name: i18n.t("messageVariablesPicker.vars.contactName"), value: "{{name}} " },
    { name: i18n.t("messageVariablesPicker.vars.greeting"), value: "{{ms}} " },
    { name: i18n.t("messageVariablesPicker.vars.protocolNumber"), value: "{{protocol}} " },
    { name: i18n.t("messageVariablesPicker.vars.hour"), value: "{{hora}} " },
];

const MessageVariablesPicker = ({ onClick, disabled }) => {
    const classes = useStyles();

    const handleClick = (e, value) => {
        e.preventDefault();
        if (disabled) return;
        onClick(value);
    };

    return (
        <OutlinedDiv
            margin="dense"
            fullWidth
            label={i18n.t("messageVariablesPicker.label")}
            disabled={disabled}
        >
            {MSG_VARS.map(msgVar => (
                <Chip
                    key={msgVar.value}
                    onMouseDown={e => handleClick(e, msgVar.value)}
                    label={msgVar.name}
                    size="small"
                    className={classes.chip}
                    color="primary"
                />
            ))}
        </OutlinedDiv>
    );
};

// Memoizado — pai (WhatsAppModal/Formik) re-renderiza a cada keystroke.
// Sem memo, o picker inteiro + 5 Chips refazem diff a cada tecla digitada
// no textarea vizinho, mesmo sem mudança nas props.
export default React.memo(MessageVariablesPicker);